import { Auth } from 'aws-amplify';
import { get } from 'lodash';

import template from 'url-template';

import {
    FETCH_CURRENT_USER_ROLE,
    SET_CURRENT_USER
} from '../actions/actionTypes';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { handleNetworkError } from './applicationMessageActions';
import { setEmails } from './dashboardActions';

const CurrentUserRoleUrl = template.parse('/companies/{companyId}/accounts{?page,limit}');

const DEFAULT_PAGE_LIMIT = 100;

export const initUser = () => async (dispatch, getState) => {
    const { attributes } = await Auth.currentUserInfo();
    let payload = getState().currentUser;

    if (attributes) {
        payload = {
            defaultCompany: attributes['custom:diDefaultCompanyId'],
            email:          attributes.email,
            firstName:      attributes.given_name,
            lastName:       attributes.family_name,
            phone:          attributes.phone_number,
            id:             attributes['custom:diAccountId'],
            userName:       `${attributes.given_name} ${attributes.family_name}`,
            isSuperUser:    payload.isSuperUser
        };
    }

    dispatch({
        type: SET_CURRENT_USER,
        payload
    });
};

export const fetchCurrentUserRole = (companyId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    const currentUser = getState().currentUser;

    let totalPayload = [];

    let user = {
        id:   currentUser.id,
        role: {...currentUser.role}
    };

    try {
        const getPayload = async (page = 1) => {
            options.limit = DEFAULT_PAGE_LIMIT;
            options.page = page;

            const response = await k2aBaseApi.get(
                CurrentUserRoleUrl.expand({
                    companyId,
                    ...options
                }),
                header
            );

            const payload = get(response, 'data.data', []);
            const totalCount = get(response, 'data.meta.totalCount', 0);

            totalPayload = [...totalPayload, ...payload];

            page++;

            if (payload.length > 0 && totalPayload.length < totalCount) {
                return await getPayload(page);
            }

            return;
        };

        await getPayload();

        const activeUser = totalPayload.find(({ email }) => email === currentUser.email);
        let emailList = totalPayload.map((user) => { return user.email; });

        if (activeUser) {
            user = {
                id:   activeUser.id,
                role: activeUser.role
            };
        }

        // set emails for validation on save configuration modal
        dispatch(setEmails(emailList));

        dispatch({
            type:    FETCH_CURRENT_USER_ROLE,
            payload: user
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const setCurrentUser = payload => {
    return {
        type: SET_CURRENT_USER,
        payload
    };
};
